import { render, staticRenderFns } from "./SimpleResultEditor.vue?vue&type=template&id=f47b691e&scoped=true"
import script from "./SimpleResultEditor.vue?vue&type=script&lang=js"
export * from "./SimpleResultEditor.vue?vue&type=script&lang=js"
import style0 from "./SimpleResultEditor.vue?vue&type=style&index=0&id=f47b691e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b691e",
  null
  
)

export default component.exports